<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5 p-2" style="transform: translateX(-19vw)">
      <Tasks_job/>
    </div>
  </div>
</template>
<script>
import {defineComponent} from "vue";
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import router from "@/router";
import Documents from "@/components/process_documentation_management/Document.vue";
import process from "@/components/process_documentation_management/proccess.vue";
import Organization from "@/components/process_documentation_management/Organization.vue";
import Tasks_job from "@/components/process_id/mother/Tasks_job_by_id.vue";
export default defineComponent({
  components: {Tasks_job, Documents, Sidebar, Splash, process, Organization},
  methods:{
    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
})
</script>